import {SECURITY_FETCH_USER, SECURITY_LOGOUT, SECURITY_REQUEST_TOKEN, SECURITY_STORE_TARGET_URL} from "../actions.type"
import {SECURITY_SET_TARGET_URL, SECURITY_SET_TOKEN, SECURITY_SET_USER} from "../mutations.type"
import {AuthenticationService} from "../../services/authentication.service";

const state = {
    user: null,
    targetURL: null,
};

const getters = {
    currentUser(state) {
        return state.user;
    },
    isCurrentUserAdmin(state) {
        return state.user && state.user.isAdmin;
    },
    targetURL(state) {
        return state.targetURL;
    }
};

const actions = {
    [SECURITY_FETCH_USER](state) {
        return AuthenticationService.getUser()
            .then(response => {
                state.commit(SECURITY_SET_USER, response.data);
            })
            .catch(error => {
                AuthenticationService.clear();
                state.commit(SECURITY_SET_USER, null);

                throw new Error(error);
            });
    },

    [SECURITY_LOGOUT](state) {
        AuthenticationService.clear();
        state.commit(SECURITY_SET_USER, null);
        state.commit(SECURITY_SET_TARGET_URL, null);
    },

    [SECURITY_REQUEST_TOKEN](state, payload) {
        return AuthenticationService.requestToken(payload)
            .then(response => {
                state.commit(SECURITY_SET_TOKEN, response.data.token);
            });
    },

    [SECURITY_STORE_TARGET_URL](state, url) {
        state.commit(SECURITY_SET_TARGET_URL, url);
    },
};

const mutations = {
    [SECURITY_SET_TARGET_URL](state, url) {
        state.targetURL = url;
    },

    [SECURITY_SET_TOKEN](state, token) {
        AuthenticationService.storeToken(token);
    },

    [SECURITY_SET_USER](state, user) {
        state.user = user;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}